import React, { useEffect, useRef, useState } from 'react'
import PageTitle from '../components/PageTitle'
import { pageTitleTexts } from '../../constants/texts/pageTitleTexts'
import { useRecoilValue } from 'recoil';
import { tenantState } from '../../store/recoil/tenant/atoms';
import { Form, Formik } from 'formik';
import FormObserver from '../components/FormElements/FormObserver';
import { Button } from '../components/Elements';
import { FormInput } from '../components/FormElements';
import ReCAPTCHA from "react-google-recaptcha";
import FooterLogo from '../components/FooterLogo';
import { createPasswordSchema } from '../../common/validators/createPasswordSchema';
import { ApiResponseType } from '../../common/api/apiHelper';
import commonNetwork from '../../common/api/commonNetwork';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { getNavigationUrl } from '../../common/helpers/navigationHelpers';
import Loading from '../components/Loading';

type FormProps = {
    password: string,
    retryPassword: string,
    firmCode: string
}

const CreatePassword = () => {
    const { firmInformations } = useRecoilValue(tenantState);
    const initialValues: FormProps = {
        password: "",
        retryPassword: "",
        firmCode: firmInformations.firmCode
    };

    const [loginLoading, setLoginLoading] = useState<boolean>(false);
    const recaptchaRef = useRef<any>();
    const [capthaLoad, setCapthaLoad] = useState<boolean>(false);
    const [showInputs, setShowInputs] = useState<boolean>(true);
    const [formValues, setFormValues] = useState(initialValues);
    const [pageLoading, setPageLoading] = useState<boolean>(true)

    useEffect(() => {
        validateToken();
    }, []);

    setTimeout(() => {
        setCapthaLoad(true);
    }, 500);

    const onUpdate = (value: FormProps) => {
        setFormValues({ ...formValues, ...value });
    };

    const searchParams = new URLSearchParams(location.search);
    const token = searchParams.get('token');

    const navigate = useNavigate();

    const onSubmit = async (values: FormProps) => {
        let result: ApiResponseType;
        const params = {
            token: token,
            password: values.password,
        }
        result = await commonNetwork.post("/user/create-user-password", params);

        if (result.isSuccess) {
            toast.success("Parola oluşturuldu.");
            navigate(getNavigationUrl("/login"));
        } else {
            toast.error("Parola oluşturulamadı.");
        }
    }

    const validateToken = async () => {
        let result: ApiResponseType;
        const params = {
            token: token
        }
        setLoginLoading(true);
        result = await commonNetwork.get("/user/validate-user-token", params)

        if (result.isSuccess) {
            setShowInputs(true);
        } else {
            setShowInputs(false);
        }
        setLoginLoading(false);
        setPageLoading(false);
    }

    return (
        <div className="flex flex-col md:flex-row h-screen items-center">

            <PageTitle showFirmInformation={true} title={pageTitleTexts.createPassword} />
            <div className="lg:block w-full md:w-1/2 xl:w-2/3 h-screen">
                <img src="/images/logopng.svg" className="w-full h-full object-cover" alt="Sample image" />
            </div>
            <div className="w-full md:w-1/3 right-side mb-4">

                <div className="max-[33%]">
                </div>
                <div className="px-6 lg:px-12 xl:px-10 text-center md:text-right justify-center md:justify-end">
                    <div className="text-center mb-8">
                        <img className="mx-auto w-48" src={`https://tahsilat.elogo.com.tr/etahsilatapitest/Uploads/firm_logos/${firmInformations.logoPath}`} alt="logo" />

                    </div>

                    <div className="flex flex-row items-center justify-center lg:justify-center m-b-10">
                        <h1 className="text-2xl font-semibold  mb-0 text-center">{firmInformations.firmName}</h1>
                    </div>


                    {pageLoading ? <Loading /> :
                        <>
                            {!showInputs ?
                                <div className="flex flex-row items-center justify-center lg:justify-center mb-8 ">
                                    <p className="text-lg font-normal mb-0 text-center">Link Geçersiz ya da süresi dolmuş</p>
                                </div>
                                :
                                <>
                                    <div className="flex flex-row items-center justify-center lg:justify-center mb-8 ">
                                        <p className="text-lg font-normal mb-0 text-center">Sisteme giriş yapabilmek için şifre oluşturunuz</p>
                                    </div>
                                    <div className="flex items-center my-4 before:flex-1 before:border-t before:border-gray-300 before:mt-0.5 after:flex-1 after:border-t after:border-gray-300 after:mt-0.5">
                                        <p className="text-center font-semibold mx-4 mb-0">Şifre Oluştur</p>
                                    </div>
                                    <div className="mb-8">

                                        <Formik
                                            validationSchema={createPasswordSchema}
                                            enableReinitialize
                                            onSubmit={onSubmit}
                                            initialValues={formValues}
                                        >
                                            {formProps => (
                                                <Form>
                                                    <FormObserver watch={(val: any) => onUpdate(val)} />
                                                    <div className="flex flex-col sm:text-left lg:text-center justify-start mt-3">
                                                        <input type="hidden" name="CaptchaToken" id="CaptchaToken" value="" />
                                                        <div className=" mt-3">
                                                            <div>
                                                                <div className="w-full relative">
                                                                    <FormInput
                                                                        label="Şifre*"
                                                                        name="password"
                                                                        type="password"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="mt-3">
                                                            <div>
                                                                <div className="w-full relative">
                                                                    <FormInput
                                                                        label="Şifreyi Tekrar Girin*"
                                                                        name="retryPassword"
                                                                        type="password"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="text-center lg:text-center mb-4">
                                                        <Button
                                                            type="submit"
                                                            color="primary"
                                                            hover="primary"
                                                            className={" w-full h-12 mt-6 px-7 py-3"}
                                                            size="xl"
                                                            disabled={loginLoading}
                                                            loading={loginLoading}
                                                        >
                                                            Şifreyi Değiştir
                                                        </Button>
                                                    </div>
                                                </Form>
                                            )}
                                        </Formik>
                                    </div>
                                </>}
                        </>}
                </div>
                {capthaLoad && (
                    <ReCAPTCHA
                        ref={recaptchaRef}
                        size="invisible"
                        sitekey="6LewgCwmAAAAAD6pjQQbOP9Dxq7AC025wgOuNZDb"
                    />
                )}
                <div
                    className="flex items-endflex items-end justify-center "
                >
                    <FooterLogo />
                </div>
            </div>

        </div>
    )
}

export default CreatePassword